import { Component } from '@angular/core';

@Component({
  selector: 'ui-skeleton-assets',
  standalone: true,
  templateUrl: './skeleton-assets.component.html',
})
export class UISkeletonAssetsComponent {}
